<div *ngIf="(businessLocations$ | async) > 1" class="pb-2">
  <h1>
    {{title}}

    <small
      *ngIf="statusIndicator"
      class="text-nowrap"
      [ngClass]="'status-' + statusIndicator"
    >
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5.5" cy="5.5" r="5.5" fill="#1CBC8C"/>
      </svg>

      <ng-container *ngIf="statusIndicator == 'running' || statusIndicator == 'stopped'; else toPublish">
        {{ statusIndicator }}
      </ng-container>

      <ng-template #toPublish>
        to publish
      </ng-template>
    </small>
  </h1>

  <!--<div class="page-title-subheading">
    {{subtitle}}
  </div>-->
</div>
